var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeshape7B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new_eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyes_x5F_4a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M409,255.7c-13.7-2.3-25.8,7.9-29.6,21c15.4,8.6,34.4,9.1,43.9-4.7C422.8,263.9,416.9,257.9,409,255.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#654023",
    cx: 402,
    cy: 267.1,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A191A",
    d: "M423.3,266.7L423.3,266.7c1.5,1.2,4.4,2.2,6.3,2.1c-3.6-1.2-7.1-4.5-9.2-8.2c1.4,0.5,5.4,0.3,6.3-0.4 c-5.2-0.1-8.7-2.6-12.7-4.5c2.6-0.6,4.2-1.3,6-3.5c-2.1,1.7-6.3,1.9-8.9,1.7c-15.4-3.4-29.8,7.7-31.8,22.7c0.1,0,0.2,0.1,0.3,0.1 c3.7-13.1,15.9-23.3,29.6-21c7.9,2.1,13.8,8.2,14.3,16.3c0.2-0.4,0.5-0.7,0.7-1.1C424,269.3,423.6,267.6,423.3,266.7L423.3,266.7z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409,255.7c-13.2-2.2-25.1,7.3-29.2,19.8c8.3-15.9,25.9-21.4,37.5-11.7c0.9,0.8,1.7,2.1,2.4,3.1c1.3,2,2.1,4,2.2,7.1 c0.5-0.6,1-1.2,1.4-1.9C422.8,263.9,416.9,257.9,409,255.7z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    enableBackground: "new    ",
    d: "M402,254.6c-6.9,0-12.5,5.6-12.5,12.5s5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5 S408.9,254.6,402,254.6z M402,255.8c2.4,0,4.7,0.8,6.5,2.1l-6.5,9.3l-0.9-11.4C401.4,255.8,401.7,255.8,402,255.8z M402,278.4 c-2.4,0-4.6-0.8-6.5-2l6.3-9l-8.3,7.2c-1.8-2-2.8-4.6-2.8-7.5c0-2,0.5-3.8,1.4-5.4l9.6,5.4l-7.9-7.7c1.3-1.4,3-2.5,4.9-3.1 l3.2,10.9l-0.2-0.1l0.2,0.2l-0.1,0.1l0.1-0.1l0,0l0.9,11.1C402.5,278.4,402.3,278.4,402,278.4z M405.1,278l-3.2-10.6l8,7.8 C408.6,276.4,407,277.4,405.1,278z M402,267.2l8.6-7.5c1.7,2,2.7,4.5,2.7,7.4c0,2-0.5,4-1.5,5.6L402,267.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 267.1,
    r: 5.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 398.9,
    cy: 264.4,
    rx: 2.9,
    ry: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 404.8,
    cy: 271.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M304.1,255.7c13.7-2.3,25.8,7.9,29.6,21c-15.4,8.6-34.4,9.1-43.9-4.7C290.3,263.9,296.2,257.9,304.1,255.7 z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#654023",
    cx: 311.1,
    cy: 267.1,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A191A",
    d: "M289.8,266.7L289.8,266.7c-1.5,1.2-4.4,2.2-6.3,2.1c3.6-1.2,7.1-4.5,9.2-8.2c-1.4,0.5-5.4,0.3-6.3-0.4 c5.2-0.1,8.7-2.6,12.7-4.5c-2.6-0.6-4.2-1.3-6-3.5c2.1,1.7,6.3,1.9,8.9,1.7c15.4-3.4,29.8,7.7,31.8,22.7c-0.1,0-0.2,0.1-0.3,0.1 c-3.7-13.1-15.9-23.3-29.6-21c-7.9,2.1-13.8,8.2-14.3,16.3c-0.2-0.4-0.5-0.7-0.7-1.1C289.1,269.3,289.4,267.6,289.8,266.7 L289.8,266.7z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.1,255.7c13.2-2.2,25.1,7.3,29.2,19.8c-8.3-15.9-25.9-21.4-37.5-11.7c-0.9,0.8-1.7,2.1-2.4,3.1c-1.3,2-2.1,4-2.2,7.1 c-0.5-0.6-1-1.2-1.4-1.9C290.3,263.9,296.2,257.9,304.1,255.7z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    enableBackground: "new    ",
    d: "M298.6,267.1c0,6.9,5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5 s-5.6-12.5-12.5-12.5S298.6,260.2,298.6,267.1z M312,255.9l-0.9,11.4l-6.5-9.3c1.8-1.3,4.1-2.1,6.5-2.1 C311.4,255.8,311.7,255.8,312,255.9z M310.3,278.4l0.9-11.1l0,0l0.1,0.1l-0.1-0.1l0.2-0.2l-0.2,0.1l3.2-10.9 c1.9,0.6,3.6,1.7,4.9,3.1l-7.9,7.7l9.6-5.4c0.9,1.6,1.4,3.4,1.4,5.4c0,2.9-1.1,5.5-2.8,7.5l-8.3-7.2l6.3,9c-1.8,1.3-4.1,2-6.5,2 C310.8,278.4,310.5,278.4,310.3,278.4z M303.1,275.1l8-7.8L308,278C306.1,277.4,304.4,276.4,303.1,275.1z M301.3,272.7 c-0.9-1.7-1.5-3.6-1.5-5.6c0-2.8,1-5.4,2.7-7.4l8.6,7.5L301.3,272.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.1,
    cy: 267.1,
    r: 5.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 314.2,
    cy: 264.4,
    rx: 2.9,
    ry: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 308.3,
    cy: 271.4,
    r: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeshape7B);
export default __webpack_public_path__ + "static/media/eyeshape_7b.d98e57528c1a80de0332c854062b9dee.svg";
export { ForwardRef as ReactComponent };